import { render, staticRenderFns } from "./IntroCompanyPage.vue?vue&type=template&id=d5147de4&scoped=true&"
import script from "./IntroCompanyPage.vue?vue&type=script&lang=js&"
export * from "./IntroCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroCompanyPage.vue?vue&type=style&index=0&id=d5147de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5147de4",
  null
  
)

export default component.exports